import React from 'react';

interface CurrentPhaseIconProps {
  circleColor?: string;
  starColor?: string;
  height?: number | string;
  width?: number | string;
  opacity?: number;
  style?: React.CSSProperties;
  className?: string;
  'aria-label'?: string;
}

const CurrentPhaseIcon: React.FC<CurrentPhaseIconProps> = ({
  circleColor = '#2372B9',
  starColor = 'white',
  height = 18,
  width = 18,
  opacity = 1,
  style,
  className,
  'aria-label': ariaLabel,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={height}
    width={width}
    viewBox="0 0 18 18"
    style={{ opacity, ...style }}
    className={className}
    aria-label={ariaLabel}
    role={ariaLabel ? 'img' : 'presentation'}
    fill="none"
  >
    <circle cx="9" cy="9" r="9" fill={circleColor} />
    <path
      d="M9.40313 3.84523C9.32626 3.69523 9.17063 3.59961 9.00188 3.59961C8.83313 3.59961 8.67751 3.69523 8.60063 3.84523L7.22063 6.54898L4.22251 7.02523C4.05563 7.05148 3.91688 7.16961 3.86438 7.33086C3.81188 7.49211 3.85501 7.66836 3.97313 7.78836L6.11813 9.93523L5.64563 12.9334C5.61938 13.1002 5.68876 13.269 5.82563 13.3684C5.96251 13.4677 6.14251 13.4827 6.29438 13.4059L9.00188 12.0296L11.7075 13.4059C11.8575 13.4827 12.0394 13.4677 12.1763 13.3684C12.3131 13.269 12.3825 13.1021 12.3563 12.9334L11.8819 9.93523L14.0269 7.78836C14.1469 7.66836 14.1881 7.49211 14.1356 7.33086C14.0831 7.16961 13.9463 7.05148 13.7775 7.02523L10.7813 6.54898L9.40313 3.84523Z"
      fill={starColor}
    />
  </svg>
);

export default CurrentPhaseIcon;
